// App.js - Main application component

import ResumeKingdom from './ResumeKingdom';

function App() {
  return (
    <div >
      <ResumeKingdom />
    </div>
  );
}

export default App;